// ==============================|| OVERRIDES - CHECKBOX ||============================== //

import { CustomTheme } from 'themes/Theme';

export default function Checkbox(theme: CustomTheme) {
    return {
        MuiCheckbox: {
            styleOverrides: {
                root: {
                    color: theme.palette.secondary[300],
                },
            },
        },
    };
}
